import script from "./FiltrosPedidoVenda.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosPedidoVenda.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosPedidoVenda.vue?vue&type=style&index=0&id=daab82b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daab82b8"]])

export default __exports__